import { useMemo } from 'react';

export const useClassName = (...classNames: (string | false | undefined)[]): string => {
    return useMemo(() => {
        if (!classNames?.length) return '';

        return classNames.filter(Boolean).join(' ');
    }, classNames);
};
